
<button
  (click)="onClick()"
  class="flex flex-col w-36 rounded-lg border-transparent text-start hover:cursor-pointer hover:border sm:w-[165px] sm:h-[275px]">
  <!-- Image Frame -->
  <div>
    <ln-ln-image-frame
      [src]="product.urlImg"
      alt="Imagen del producto"
      class="h-[165px] w-[165px] rounded-lg"
      width="165"
      height="165"
    >
    </ln-ln-image-frame>
  </div>

  <!-- Product Name -->
  <div
    class="mt-2 line-clamp-2 w-36 overflow-hidden text-ellipsis break-words font-['Roboto'] text-base font-normal text-cafe">
    {{ product.nombre }}
  </div>
  @if (showPrice) {
    <!-- Price -->
    @if (product.precioOferta !== null && product.precio !== null) {
      <div class="font-['Roboto'] text-base font-bold text-cafe">
        {{ product.precioOferta | priceFormat }} <span class="text-xs font-bold"> USD</span>
      </div>
      <div class="font-['Roboto'] text-sm font-normal text-verde">
        <span class="line-through">{{ product.precio | priceFormat }} </span> <span class="text-xs font-normal"> USD</span>
      </div>
      }
     @else {
      @if (product.precio !== null) {
      <div class="font-['Roboto'] text-base font-bold text-cafe text-start">
        {{ product.precio | priceFormat }} <span class="text-xs font-bold"> USD</span>
      </div>
      }
    }
  }
</button>
